import { defineMessages } from 'react-intl'

export default defineMessages({
    title: {
        id: 'containers.CustomerPage.CustomerInfo.components.FinancialStats.title',
        defaultMessage: 'Financial stats',
    },
    description: {
        id: 'containers.CustomerPage.CustomerInfo.components.FinancialStats.description',
        defaultMessage: 'Current financial year ({fiscalCurrentYear}) compared to last financial year ({fiscalLastYear})',
    },
    loading: {
        id: 'containers.CustomerPage.CustomerInfo.components.FinancialStats.loading',
        defaultMessage: 'Loading financial stats',
    },
    revenue: {
        id: 'containers.CustomerPage.CustomerInfo.components.FinancialStats.revenue',
        defaultMessage: 'Revenue',
    },
    revenue_percentage: {
        id: 'containers.CustomerPage.CustomerInfo.components.FinancialStats.revenue_percentage',
        defaultMessage: 'Revenue share',
    },
    gross_margin: {
        id: 'containers.CustomerPage.CustomerInfo.components.FinancialStats.gross_margin',
        defaultMessage: 'Gross margin %',
    },
    growth: {
        id: 'containers.CustomerPage.CustomerInfo.components.FinancialStats.growth',
        defaultMessage: 'Growth',
    },
    from: {
        id: 'containers.CustomerPage.CustomerInfo.components.FinancialStats.from',
        defaultMessage: 'from {fromValue}',
    },
})